<template>
  <div class="form-group">
    <div class="form">
      <label>
        <input type="checkbox" class="custom-input" v-model="value" @change="changeValue" @keyup="changeValue">
        {{labelDesc}}
      </label>
      <div v-if="warning" class="ct-alert-container" style="margin-top: 10px;">
				<div class="ct-alert-content">
					{{warning}}
				</div>
			</div>
    </div>
  </div>
</template>

<script>

	export default {
		name: 'CheckComponent',
		data() {
			return {
				element: null,
				value: '',
				labelDesc: 'opa',
        warning: '',
				callback: null,
			}
		},
		methods: {
			changeValue() {
				this.callback();
			},
			setValues(obj) {
				// console.log(obj, 'eai');
				this.value = obj.defaultValue;
				this.warning = obj.warning;
				this.element = obj.element;
        this.labelDesc = this.$t(`ct-${obj.labelDesc}`);
				this.callback = obj.callback;
			}
		},
	}

</script>

<style scoped lang="scss">
  .form-group {
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/resources/Check.vue